import { useCallback } from 'react';
import { auth } from 'utils/auth/auth';
import { useAuthentication } from 'components/AuthenticationProvider/AuthenticationProvider';
import { attemptedActionStore } from 'helpers/attemptedActionStore';
import { noop } from 'utils/noop';
import { AnyAuthenticatedUserAction } from 'types';

export type PrivateActionConfig = {
    handleAuthenticated?: () => void;
    handleGuest?: () => void;
    actionDescription: AnyAuthenticatedUserAction;
};

export function usePrivateAction(): (
    actionConfig: PrivateActionConfig,
) => void {
    const { isAuthenticated } = useAuthentication();

    const doPrivateAction = useCallback(
        ({
            handleAuthenticated = noop,
            handleGuest = noop,
            actionDescription,
        }: PrivateActionConfig) => {
            if (isAuthenticated) {
                handleAuthenticated();
            } else {
                handleGuest();
                attemptedActionStore.set(actionDescription);

                auth.signup();
            }
        },
        [isAuthenticated],
    );

    return doPrivateAction;
}
